import {
  Button,
  Drawer,
  Form,
  Space,
  DatePicker,
  Select,
  TimePicker,
} from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import moment from "moment";

const CreateLogs = ({ open, close, employeeInfo, rerun }) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [selectedDate, setSelectedDate] = useState(null);
  const [daySubStatus, setDaySubStatus] = useState(null);
  const [timeIn, setTimeIn] = useState(null);
  const [timeOut, setTimeOut] = useState(null);

  const handleCreateAbsentLog = (values) => {
    const formdata = new FormData();
    formdata.append("store_time_in", userData.data.id);
    formdata.append("store_time_out", userData.data.id);
    formdata.append(
      "user_id",
      employeeInfo.ready && employeeInfo.data[0].user_id
    );
    formdata.append("day_status", "active");
    formdata.append("current_time_in", timeIn !== null ? timeIn : null);
    formdata.append("current_time_out", timeOut !== null ? timeOut : "");
    formdata.append("schedule_day", moment(selectedDate).format("dddd"));

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    // setLoading(true);
    axios
      .post("user/merchant/create/employee-absent-log", formdata)
      .then((response) => {
        const data = response.data;
        if (data.message === "success") {
          rerunNotif("success", "Created log successfully.");
          setTimeout(() => {
            rerun();
            close();
            setLoadings(false);
            // setLoading(false);
          }, 1000);
        }
        if (data.message === "schedule-not-matched") {
          rerunNotif("error", "Employee have no schedule this specific date.");
          setTimeout(() => {
            setLoadings(false);
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Drawer
      title="Create Log"
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="add-employee-log"
        onFinish={handleCreateAbsentLog}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="day_sub_status"
            label="Status"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              size="large"
              onChange={(e) => {
                setDaySubStatus(e);
              }}
            >
              <Select.Option value={"present"}>Present</Select.Option>
              <Select.Option value={"absent"}>Absent</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="current_date"
            label="Date"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <DatePicker
              format={"MM/DD/YYYY"}
              size="large"
              style={{ width: "100%" }}
              onChange={(e) =>
                setSelectedDate(moment(new Date(e)).format("YYYY-MM-DD"))
              }
            />
          </Form.Item>

          {daySubStatus === "present" && (
            <>
              <Form.Item
                name="time_in"
                label="Time in"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <TimePicker
                  format={"HH:mm"}
                  onChange={(value, dateString) => {
                    if (dateString !== "") {
                      var date = `2023-11-23 ${dateString}:00`;
                      var finalDate = moment(
                        `${date.replace(" ", "T")}.000000Z`
                      )
                        .utc()
                        .format("HH:mm:ss");
                      setTimeIn(finalDate);
                    } else {
                      setTimeIn(null);
                    }
                  }}
                  size="large"
                  required
                  style={{ width: "100%" }}
                />
              </Form.Item>

              <Form.Item
                name="time_out"
                label="Time out"
                rules={[
                  {
                    required: false,
                    message: "Required",
                  },
                ]}
              >
                <TimePicker
                  format={"HH:mm"}
                  onChange={(value, dateString) => {
                    if (dateString !== "") {
                      var date = `2023-11-23 ${dateString}:00`;
                      var finalDate = moment(
                        `${date.replace(" ", "T")}.000000Z`
                      )
                        .utc()
                        .format("HH:mm:ss");
                      setTimeOut(finalDate);
                    } else {
                      setTimeOut(null);
                    }
                  }}
                  size="large"
                  required
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </>
          )}
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default CreateLogs;
